// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__3seAn","main":"Layout_main__bHK8S"};